// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var ChevronLeft = React.forwardRef(function ChevronLeft(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ChevronLeft" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 12L14.1611 5L16 6.79759L10.6779 12L16 17.2024L14.1611 19L7 12Z", fill: "currentColor" }))));
});
ChevronLeft.displayName = 'ChevronLeft';
export default ChevronLeft;
//# sourceMappingURL=ChevronLeft.js.map